export default __webpack_public_path__ + "static/media/download.457dac10.svg";